/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import React from 'react';

import {OverviewPeriodRange, OverviewReturn} from '../../../../util/interfaces';

import {getOverviewReturns} from '../../../../util/requestSender';

import {useOverviewSection} from '../useOverviewSection';

import Returns from './returns';

interface Props {
    accountIds: Array<string>;
    period: OverviewPeriodRange;
}

export default function ReturnsController({accountIds, period}: Props) {
    const section = useOverviewSection<OverviewReturn>({request: getOverviewReturns, accountIds, period});

    return <Returns {...section} />;
}
